import React, { useState } from "react";
import Select from "react-select";
import { FiX } from "react-icons/fi";
import { FaUserAlt, FaUser, FaRegCalendarAlt, FaShieldAlt } from "react-icons/fa";
import { postAssetTransferRequest } from "../../ApiHelper/url_Helpers";
import { toasterError, toasterSuccess } from "../../Components/toaster";

const AssetTransferModal = ({ isOpen, onClose, asset, assignmentId, employeeList }) => {
  const [transferTo, setTransferTo] = useState("");
  const [reason, setReason] = useState("");
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!transferTo || !reason) return alert("Please fill mandatory fields");
    try {
      setLoading(true);
      await postAssetTransferRequest({
        asset_id: assignmentId || asset?.id,
        employee_id: transferTo,
        transfer_to: transferTo,
        reason: reason,
        remarks: remarks
      });
      toasterSuccess("Transfer request submitted successfully");
      onClose();
    } catch (error) {
      console.error("Transfer error:", error);
      toasterError("Failed to submit transfer request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 pt-4 px-4">
      <div className="bg-[#f8fafc] rounded-xl max-w-2xl w-full  max-h-[90vh] overflow-y-auto shadow-xl flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-start p-3 border-b border-gray-200 bg-white rounded-t-xl">
          <div>
            <h2 className="text-xl font-bold text-gray-800">Asset Transfer Request</h2>
            <p className="text-sm text-gray-500 mt-1">Fill in the details below to request an asset transfer.</p>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-md transition-colors">
            <FiX className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="flex flex-col md:flex-row p-4 ">
          {/* Left Side: Form */}
          <div className="flex-1 bg-white p-6 rounded-xl border border-gray-100 shadow-sm space-y-6">
            <div>
              {/* <h4 className="text-lg font-semibold text-gray-800 mb-4">Transfer To</h4> */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Transfer To (Employee) <span className="text-red-500">*</span>
                  </label>
                  <Select
                    options={employeeList.map(emp => ({ value: emp.id, label: emp.full_name }))}
                    value={employeeList.find(emp => emp.id === transferTo) ? { value: transferTo, label: employeeList.find(emp => emp.id === transferTo).full_name } : null}
                    onChange={(selected) => setTransferTo(selected ? selected.value : "")}
                    placeholder="Select Employee"
                    className="text-sm"
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderColor: '#e5e7eb',
                        '&:hover': { borderColor: '#06b6d4' },
                        boxShadow: 'none',
                        minHeight: '38px',
                      }),
                      menu: (base) => ({ ...base, zIndex: 9999 }),
                      menuList: (base) => ({ ...base, maxHeight: '200px' })
                    }}
                    isClearable
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Employee Name
                    </label>
                    <input
                      type="text"
                      value={employeeList.find((emp) => emp.id === transferTo)?.full_name || ""}
                      disabled
                      className="w-full border border-gray-200 rounded-md p-2 text-sm bg-gray-50 text-gray-500"
                    />
                  </div>
                  <div className="">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Designation
                    </label>
                    <input
                      type="text"
                      value={employeeList.find((emp) => emp.id === transferTo)?.designation || ""}
                      disabled
                      className="w-full border border-gray-200 rounded-md p-2 text-sm bg-gray-50 text-gray-500"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Reason for transfer <span className="text-red-500">*</span>
              </label>
              <textarea
                rows={2}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                className="w-full border border-gray-200 rounded-md p-2 text-sm focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500"
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className=" sticky bottom-0 flex justify-end gap-3 p-6 border-t border-gray-200 bg-white rounded-b-xl mt-auto sticky">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-2 bg-[#00bcd4] rounded-md text-sm font-medium text-white hover:bg-cyan-600 disabled:bg-gray-400"
          >
            {loading ? "Submitting..." : "Submit Request"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssetTransferModal;
